// extracted by mini-css-extract-plugin
module.exports = {"container":"CargoOptionalFeatures_container__1sYLY","checkBoxContainer":"CargoOptionalFeatures_checkBoxContainer__2SrAw"};